export const teqipFileInfo =[
    {
        "Heading" : "Click here for SVU Annual Report",
        "fileSource" : "/TEQIP/SVU_Annual_Report.pdf"
    }
]